import React, {useState} from "react";
import {validateCoupon} from "../api";
import "./CouponField.css";

// Coupon input for checkout. Checks the code with the server, then reports
// {code, percent} (or null when removed) through onChange. The server checks
// the code again when the order is placed, so this is only for showing the price.
// `p` is the class prefix, so each storefront theme can style it its own way.
export default function CouponField({coupon, onChange, p = "co"}) {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [checking, setChecking] = useState(false);

  async function apply(e) {
    e.preventDefault();
    if (!code.trim()) return;
    setChecking(true);
    setError("");
    try {
      const {data} = await validateCoupon(code.trim());
      onChange(data);
      setCode("");
    } catch (err) {
      setError(err?.response?.data?.message || "Could not apply this coupon");
    } finally {
      setChecking(false);
    }
  }

  if (coupon)
    return (
      <div className={`${p}-coupon ${p}-coupon-applied`}>
        <span>
          🏷️ <b>{coupon.code}</b> applied · {coupon.percent}% off
        </span>
        <button type="button" onClick={() => onChange(null)}>
          Remove
        </button>
      </div>
    );

  return (
    <form className={`${p}-coupon`} onSubmit={apply}>
      <div className={`${p}-coupon-row`}>
        <input
          value={code}
          onChange={(e) => {
            setCode(e.target.value.toUpperCase());
            setError("");
          }}
          placeholder="Coupon code"
          aria-label="Coupon code"
        />
        <button type="submit" disabled={checking || !code.trim()}>
          {checking ? "…" : "Apply"}
        </button>
      </div>
      {error && <p className={`${p}-coupon-error`}>{error}</p>}
    </form>
  );
}
